import { Box, styled } from '@mui/material';

const StyledWeeklySessionEventContainer = styled(Box)(({ theme }) => ({
  // Las tarjetas de sesión conservan SIEMPRE la superficie oscura + texto blanco
  // (idénticas al modo oscuro), aunque el calendario sea claro. Así no se pierde el
  // contraste negro/blanco y se distinguen las sesiones programadas de las pasadas
  // (estas últimas se atenúan por la opacidad de la columna pasada). El calendario en
  // sí sigue siendo mode-aware; solo las sesiones se mantienen oscuras.
  backgroundColor: '#1F2327',
  color: '#FFFFFF',
  borderRadius: '6px',
  cursor: 'pointer',
  // Llena toda la franja de la hora (la card ocupa su espacio completo, no se ve "corta").
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.06)',
  [theme.breakpoints.up('md')]: {
    borderRadius: '8px'
  }
}));

export default StyledWeeklySessionEventContainer;
